import { render } from "./P001.vue?vue&type=template&id=0d1b061e&scoped=true"
import script from "./P001.vue?vue&type=script&lang=js"
export * from "./P001.vue?vue&type=script&lang=js"

import "./P001.vue?vue&type=style&index=0&id=0d1b061e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1b061e"]])

export default __exports__